import { subscribe, publish, THEME_EVENTS } from "../../shared/events";
import { formatMoney } from "../../shared/utils";

class QuickAddButton extends HTMLElement {
  connectedCallback() {
    this.variantSelects = this.querySelector("variant-selects");
    this.variantInput = this.querySelector('input[name="id"]');

    this.priceEl = this.querySelector("[data-quick-add-button-price]");
    this.comparePriceEl = this.querySelector(
      "[data-quick-add-button-compare-price]",
    );

    this.submitButton = this.querySelector('[type="submit"]');
    this.quickAddId = this.dataset.quickAddId || null;
    this.moneyFormat = window.theme?.settings?.moneyFormat || "{{amount}}";
    this.currency = window.Shopify?.currency?.active || "";

    this.unsubscribe = subscribe(
      THEME_EVENTS.optionValueSelectionChange,
      this.onOptionChange.bind(this),
    );
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  onOptionChange({ data: { event } }) {
    if (!this.contains(event.target)) return;

    const variant = this.variantSelects?.currentVariant;
    if (!variant) return;

    // update variant id
    if (this.variantInput) {
      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // update price
    if (this.priceEl) {
      this.priceEl.innerHTML = formatMoney(
        variant.price,
        this.moneyFormat,
        this.currency,
      );
    }

    // update compare price
    if (this.comparePriceEl) {
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        this.comparePriceEl.innerHTML = formatMoney(
          variant.compare_at_price,
          this.moneyFormat,
          this.currency,
        );
        this.comparePriceEl.classList.remove("hidden");
      } else {
        this.comparePriceEl.classList.add("hidden");
        this.comparePriceEl.innerHTML = "";
      }
    }

    // update button state
    if (this.submitButton) {
      this.submitButton.disabled = !variant.available;
    }

    /*publish(THEME_EVENTS.variantChange, {
      data: {
        variant,
        source: this,
        quickAddId: this.quickAddId,
        originalEvent: event,
      },
    });*/
  }
}

if (!customElements.get("quick-add-button")) {
  customElements.define("quick-add-button", QuickAddButton);
}
